import AuthClient from "./clients/AuthClient";
import DepartmentsClient from "./clients/DepartmentsClient.js";
import DesignationsClient from "./clients/DesignationsClient.js";
import OfficialsClient from "./clients/OfficialsClient";
import AppointmentsClient from "./clients/AppointmentsClient.js"
import UploadClient from "./clients/UploadClient";
import VisitorsClient from "./clients/VisitorsClient";
import SystemUsersClient from "./clients/SystemUsersClient";
import LiveCommunicationsClient from "./clients/LiveCommunicationsClient";
import MeetinsClient from "./clients/MeetingsClient";

// const baseHost = "apnt-api.rdcd.gov.bd";
const baseHost = "43.229.15.199:46268";
// const baseHost = "172.245.92.226:46268";
// const baseHost = "192.168.0.190:46268";
// const baseHost = "127.0.0.1:46268";
const host = "http://" + baseHost;
const wsUrl = "ws://" + baseHost + "/ws";
const apiKey = 'Q1Vj3gXoeJPHrowMMJ5KrKTyVzljjXx51ur3mG8vJYaG';


const authClient = new AuthClient(host, apiKey);
const departmentsClient = new DepartmentsClient(host, apiKey);
const designationsClient = new DesignationsClient(host, apiKey);
const officialsClient = new OfficialsClient(host, apiKey);
const visitorsClient = new VisitorsClient(host, apiKey);
const appointmentsClient = new AppointmentsClient(host, apiKey);
const uploadClient = new UploadClient(host, apiKey);
const systemUsersClient = new SystemUsersClient(host, apiKey);
const liveCommunicationsClient = new LiveCommunicationsClient(host, apiKey);
const meetingsClient = new MeetinsClient(host, apiKey);

export {
    host,
    wsUrl,
    apiKey,
    authClient,
    departmentsClient, 
    designationsClient,
    officialsClient,
    visitorsClient,
    appointmentsClient,
    uploadClient,
    systemUsersClient,
    liveCommunicationsClient,
    meetingsClient
};